export default {
  "content": "<path d=\"M7.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM3 3a1 1 0 01.948.684L4.721 6H9v2H5.344l2.4 8h10.512l.911-3.037 1.916.574-1.125 3.75A1 1 0 0119 18H7a1 1 0 01-.958-.713l-3-10L2.279 5H.5V3H3z\" fill=\"#7B61FF\"/><path d=\"M23.207 6.293a1 1 0 01.066 1.34l-.066.074-4.5 4.5-1.414-1.414L20.086 8H11V6h9.086l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};